import React from 'react';
import Icon from '@/components/ui/AppIcon';
import AppImage from '@/components/ui/AppImage';

interface ContactHeroProps {
  title: string;
  subtitle: string;
  responseTime: string;
}

const ContactHero: React.FC<ContactHeroProps> = ({ title, subtitle, responseTime }) => {
  return (
    <section className="relative py-20 lg:py-28">
      {/* Background Image with Overlay */}
      <div className="absolute inset-0">
        <AppImage
          src="/assets/images/contact_hero_professional_legal_background.png"
          alt="Professional law firm office interior with elegant modern design and sophisticated navy blue and gold decor"
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-br from-primary/95 via-navy-dark/90 to-charcoal/95" />
      </div>
      
      <div className="absolute inset-0 bg-[radial-gradient(circle_at_30%_50%,rgba(212,175,55,0.1),transparent_50%)]" />
      
      <div className="relative max-w-7xl mx-auto px-6 lg:px-8">
        <div className="max-w-3xl">
          <div className="flex items-center space-x-3 mb-6">
            <div className="p-3 bg-accent/20 rounded-lg backdrop-blur-sm">
              <Icon name="ChatBubbleLeftRightIcon" size={32} className="text-accent" variant="solid" />
            </div>
            <span className="text-accent font-semibold text-sm uppercase tracking-wider">
              Get In Touch
            </span>
          </div>
          
          <h1 className="text-4xl lg:text-5xl xl:text-6xl font-serif font-bold text-white mb-6 leading-tight">
            {title}
          </h1>
          
          <p className="text-xl text-white/80 mb-8 leading-relaxed">
            {subtitle}
          </p>
          
          <div className="flex items-center space-x-3 p-4 bg-white/10 backdrop-blur-sm rounded-lg border border-white/20 inline-flex">
            <Icon name="ClockIcon" size={24} className="text-accent" variant="outline" />
            <span className="text-white font-medium">{responseTime}</span>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ContactHero;